import { render } from "./PostRelatedModel.vue?vue&type=template&id=4a596d50"
import script from "./PostRelatedModel.vue?vue&type=script&lang=js"
export * from "./PostRelatedModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__